import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { useFeatureFlag } from '@application/feature_flags/use_feature_flag';
import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';
import { getAbsoluteRoute } from '@module/get_absolute_route';
import { useResolve } from '@visiba/instantiation';
import { useEffect } from 'react';
import { useParams } from 'react-router';

export function ScreenDone() {
	const { conversationId } = useParams();
	const universalConfig = useResolve(UniversalConfig);
	const analyticCtx = useAnalyticContext();
	// TODO: Move this behavior into configuration instead of using the NHS navigation feature toggle.
	const hasNhsNavigation = useFeatureFlag('PatientWeb.NHS.Navigation');

	useEffect(() => {
		analyticCtx.service.trackPageView({
			customTitle: 'Create new message: Done',
		});
	}, [analyticCtx]);

	function handleNextClick() {
		analyticCtx.trackEvent('Clicked', 'Go to case button');

		// Client-side routerService.navigateByUrl leaves this flow's route tree stuck rendered
		// after leaving a flow route (e.g. this create-new-message flow); a real URL change reliably resets it.
		// The router's basename (licence holder alias) isn't applied to window.location, so it's prepended here.
		const path = conversationId ? `visits/message/${conversationId}` : 'visits';
		window.location.href = getAbsoluteRoute([universalConfig.alias, path].filter(Boolean).join('/'));
	}

	return (
		<>
			<TopBar.Content onAbort={null} />
			<IllustrativeView
				title={withTranslation('View.CreateNewMessage.ScreenDone.Title')}
				description={withTranslation('View.CreateNewMessage.ScreenDone.Description')}
				illustration='messageSent'
				callToAction={hasNhsNavigation ? undefined : withTranslation('View.CreateNewMessage.ScreenDone.Button')}
				callToActionCallback={handleNextClick}
			/>
		</>
	);
}
